import { render, staticRenderFns } from "./tiny-editor.vue?vue&type=template&id=b2e9a162&"
import script from "./tiny-editor.vue?vue&type=script&lang=js&"
export * from "./tiny-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports